import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import FAQ from './FAQ';
import { makeSelectCategories } from './selectors';
import HeroSlideShow from '../HeroSlideShow';
import IllustCategoriesBanner from '../../../static/images/banner-category/slideshow-illust_ac.jpg';
import withI18next from '~/../hocs/_withI18next';
import Container from '~/components/Container';
import I18nLink from '~/components/I18nLink';
import Config from '~/config';
import { setIsTopBannerVisible } from '~/containers/HomePage/actions';
import {
  makeSelectProfile,
  makeSelectIsAuthenticated,
} from '~/containers/AuthProvider/selectors';
import themeVariables from '~/shared/themeVariables';
import { USER_ROLES } from '~/utils/constants';
import CategoriesGrid from '~/components/CategoriesGrid';
import SEOTextACworks from '~/components/SEOTextACworks';
import SEOTextSub from '~/components/SEOTextSub';

import CategoryBreadcrumb from '~/components/CategoryBreadcrumb';
import HeroBanner from '~/containers/HeroBanner';
import TagTrending from '~/components/TagTrending';
import { makeSelectIsCountdownActive } from '~/containers/PaymentModal/selectors';
import BannerDiscount from '~/components/BannerDiscount';

const roles = Config.getRoles();

@withI18next(['page-categories'])
class CategoriesPage extends React.Component {
  handleSignUpSSO = () => {
    const { lng } = this.props;
    window.open(
      `${
        Config.ssoServerUrl
      }/signup?lang=${lng}&serviceURL=${encodeURIComponent(
        window.location.href,
      )}`,
      '_blank',
    );
  };

  renderOtherService = (data) => {
    const { t } = this.props;

    const key = Object.keys(data).filter((serviceType) => {
      return serviceType !== 'categories';
    });

    return key.map((serviceType) => {
      return (
        <Container
          style={{ paddingTop: 64, paddingBottom: 20 }}
          key={serviceType}
        >
          <div className="categories-header">
            <h2 className="categories-title">
              {t(`${Config.getPrefix(serviceType)}_explore_more_from`)}
            </h2>
            <I18nLink href="/categories" host={Config.getSiteURL(serviceType)}>
              <a
                className="link-category-otherservice"
                target="_blank"
                rel="noreferrer"
              >
                {t('view_all')}
              </a>
            </I18nLink>
          </div>
          <CategoriesGrid
            categories={data[serviceType]}
            serviceType={serviceType}
          />
          <style jsx>
            {`
              .categories-header {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                margin-bottom: 32px;
              }
              .categories-title {
                font-weight: 600;
                font-size: 24px;
                margin: 0;
                padding: 0;
              }
              .link-category-otherservice {
                font-weight: 600;
                font-size: 16px;
                text-align: right;
                width: 80px;
              }
              .link-category-otherservice:hover {
                text-decoration-line: underline !important;
                color: ${themeVariables.colors.link};
                opacity: 0.8;
              }
              @media (max-width: ${themeVariables.breakpoints.mobile
                  .maxWidth}px) {
                .categories-title {
                  font-size: 18px;
                }
              }
            `}
          </style>
        </Container>
      );
    });
  };

  render() {
    const {
      t,
      categories,
      lng,
      profile,
      isCountdownActive,
      isAuthenticated,
    } = this.props;
    const displayedCategories = categories.categories.filter(
      (item) => item.categoryImage,
    );
    const isDiscountDisplayed =
      profile.role !== roles.PREMIUM &&
      profile.role !== roles.CREATOR &&
      isCountdownActive;

    return (
      <div className="categories-page">
        {Config.isDesignAC() ? (
          <HeroSlideShow />
        ) : (
          <HeroBanner
            imageURL={
              Config.isIllustAC()
                ? IllustCategoriesBanner
                : `${Config.staticPrefix}/static/images/banner-category/slideshow-${Config.serviceType}.jpg`
            }
            title={t(Config.getPrefixContent('title_slide_show_category'))}
            subTitle={t(Config.getPrefixContent('content_slide_show_category'))}
            altImage="Royalty free clipart, illustrations and vectors in categories by illustAC"
          />
        )}
        {isDiscountDisplayed && <BannerDiscount />}

        <Container style={{ paddingTop: 64, paddingBottom: 64 }}>
          <CategoryBreadcrumb />
          <CategoriesGrid categories={displayedCategories} />
        </Container>
        <Container
          style={{
            background: themeVariables.color.gray,
            paddingTop: 32,
            paddingBottom: 32,
          }}
        >
          <p className="summary-category-page">
            {t(Config.getPrefixContent('summary_category_page'))}
          </p>
        </Container>
        <TagTrending />
        {this.renderOtherService(categories)}
        <FAQ t={t} lng={lng} />
        {!isAuthenticated && (Config.isIllustAC() || Config.isPhotoAC()) && (
          <SEOTextSub t={t} lng={lng} />
        )}
        {/* {!isAuthenticated && <SEOTextACworks />} */}
        <style jsx>
          {`
            .categories-page {
              margin-bottom: 64px;
            }

            .summary-category-page {
              display: flex;
              flex-direction: row;
              justify-content: center;
              font-weight: 500;
            }
            .categories-title {
              font-weight: 600;
              font-size: 24px;
              margin: 0;
              padding: 0;
              margin-bottom: 32px;
            }
            .link-category-otherservice {
              font-weight: 600;
              text-align: right;
              width: 90px;
            }
            .link-category-otherservice:hover {
              text-decoration-line: underline !important;
              color: ${themeVariables.colors.link};
              opacity: 0.8;
            }
            @media (max-width: ${themeVariables.breakpoints.mobile
                .maxWidth}px) {
              .categories-title {
                font-size: 18px;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  categories: makeSelectCategories(),
  profile: makeSelectProfile(),
  isAuthenticated: makeSelectIsAuthenticated(),
  isCountdownActive: makeSelectIsCountdownActive(),
});
const mapDispatchToProps = (dispatch) => ({
  setIsTopBannerVisible: (value) => dispatch(setIsTopBannerVisible(value)),
});
export default connect(mapStateToProps, mapDispatchToProps)(CategoriesPage);
